<ngx-spinner
        bdColor="rgba(22,42,112,1)"
        size="medium"
        color="#fff"
        type="ball-spin"
>
</ngx-spinner>

<div>
    <p class="text-white text-center">Autenticando ...</p>

    <p class="text-white text-center" style="font-size: 14px" *ngIf="token">TOKEN:<br/><br/> {{token}}</p>

    <p class="text-white text-center" style="font-size: 14px" *ngIf="error">Error: <br/><br/> {{error}}</p>
</div>


<div class="modal-custom modal fade" id="modalLoginEmail" data-keyboard="false"
     data-backdrop="static" role="dialog"
     aria-labelledby="modalNoteResumeLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <div class="modal_header">
                <p class="header-title ml-2">Login</p>
                <a (click)="closeLoginMock()" class="btn" type="button">
                    <svg-icon src="assets/svg/dismiss.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body">
                <div class="col-12 text-center">
                    <div style="gap: 17px">
                        <div class="input-material" style="flex-grow:3">
                            <input id="start" type="text" class="form-control" [(ngModel)]="modelIdentifierMock"/>
                            <label for="start" class="text-left">{{'cpf'|translate}}</label>
                        </div>
                    </div>
                    <button class="btn btn-warning mt-3 align-middle" (click)="onLoginMock()">{{'entrar'|translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
